import { Tooltip, TooltipContent, TooltipTrigger } from "@radix-ui/react-tooltip"

import { Button } from "@/components/button"
import { cn } from "@/domains/library"
import { TokenInputSymbol } from "@/domains/tokens/components/token-input-symbol"

export type ITokenPercentageButton = {
  symbol: string
  imageURL: string
  decimals: number
  calculateValue: (percentage: number) => string
}

export const TokenPercentageButton = ({
  className,
  disabled,
  hideTooltip = false,
  label,
  onClick,
  token,
  percentage,
}: {
  className?: string
  disabled?: boolean
  hideTooltip?: boolean
  label: string
  token: ITokenPercentageButton | null | undefined
  percentage: number
  onClick?: (value: string) => void
}) => {
  if (!token) {
    return null
  }

  const button = (
    <Button
      className={cn(className, "text-[10px] xs:text-sm")}
      variant={"percentage"}
      onClick={() => {
        if (disabled) return
        onClick?.(token?.calculateValue(percentage) ?? "0")
      }}
      disabled={disabled}
    >
      {label}
    </Button>
  )

  if (hideTooltip || disabled) return button

  return (
    <Tooltip>
      <TooltipTrigger asChild>{button}</TooltipTrigger>
      <TooltipContent
        side="bottom"
        className="flex flex-col items-end gap-1 border border-p400-light bg-p400 px-1 py-0.5 text-sm text-t200"
      >
        <span>{token?.calculateValue(percentage) ?? "0"}</span>
        <TokenInputSymbol token={token} size={16} className="text-sm font-normal leading-none" />
      </TooltipContent>
    </Tooltip>
  )
}
